// extracted by mini-css-extract-plugin
module.exports = {"customSlideOptionsContainer":"CampaignTemplateCreatePage_customSlideOptionsContainer__DqKiN"};